/**
 * Started when it is injected and cancelled with `task.cancel()` when ejected
 * for improved performance.
 * @type {String}
 */
export const RESTART = '@@saga-injector/restart'
/**
 * Starts the saga upon being injected and never cancels it or starts again.
 * @type {String}
 */
export const DAEMON = '@@saga-injector/daemon'
/**
 * Behaves like {@link RESTART} but runs only once and never again.
 * @type {String}
 */
export const ONCE = '@@saga-injector/once'

/**
 * The mode with which to run a saga.
 * @global
 * @typedef {(RESTART|ONCE|DAEMON)} SAGA_MODE
 * @see {@link SagaDescriptor} for more information about usage.
 */

/**
 * Enum for the different saga modes.
 * @readonly
 * @global
 * @enum {SAGA_MODE}
 */
export const SAGA_MODES = {
  RESTART,
  DAEMON,
  ONCE
}

export const GENERIC_PURECARS_DOMAIN = '.purecars.com'
